import { AdvisoryBanner } from '../advisory-banner';

interface OptimalMixBannerProps {
  /**
   * Display name of the asset's classification (e.g. "Feature/Benefit").
   * Woven into the subtitle so the message names the asset class that is out
   * of the category's optimal mix.
   */
  classification: string;
  /**
   * Optional class name for the root element.
   * @optional
   */
  className?: string;
}

/**
 * Advisory banner shown in the Spark UI when the asset being sparked belongs to
 * a classification that is not part of its product category's optimal mix, so
 * generated images tend to score lower. Purely presentational — the caller owns
 * the decision of when to render it.
 */
function OptimalMixBanner(props: OptimalMixBannerProps) {
  const { classification, className } = props;

  return (
    <AdvisoryBanner
      title="Not in this category's optimal mix"
      description={`${classification} assets aren't part of the optimal asset mix for this category, so what you generate here tends to score lower.`}
      className={className}
    />
  );
}

export { OptimalMixBanner };
export type { OptimalMixBannerProps };
